export default {
  data() {
    return {
      total: 0,
      pages: 1,
      pagePagination: {
        from: 1,
        size: 10
      }
    };
  },
  computed: {
    canLoadNextPage() {
      return this.pagePagination.from < this.pages;
    }
  },
  watch: {
    pagePagination: {
      deep: true,
      handler: function() {
        this.setTableData();
      }
    }
  },
  methods: {
    setPaginationFrom(val) {
      this.pagePagination.from = val;
    },

    setPaginationSize(val) {
      this.pagePagination.size = val;
    },

    resetPaginationFrom() {
      if (this.pagePagination.from === 1) {
        return false;
      }
      this.pagePagination.from = 1;
      return true;
    },

    loadNextPage() {
      if (this.canLoadNextPage) {
        this.pagePagination.from++;
      } else {
        return;
      }
    }
  }
};
